module.exports = __webpack_public_path__ + "img/iconfinder_menu-alt_134216.6d2e052e.svg";